import styled from 'styled-components';

export const StyledSpacer = styled.div`
  flex-grow: 1;
`;